export default __webpack_public_path__ + "static/LibreBaskerville-Regular-677d0f4913f3c8ded76f9370e6953145.woff";